import axios from "axios";
import QueryService from "../../services/queryServices";
import { BACKEND_API_URL } from "../../config/config";
import { GetAPIParams } from "../../models/queryService.model";
const getConfig = () => {
	return {
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
			"Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSRIPTION_KEY,
		},
		data: {},
	};
};

export const cdFetch = async (path: string, options = getConfig()) => {
	const response = await axios.get(
		process.env.REACT_APP_deployed_URL + path,
		options
	);
	return response; // Or handle other response types as needed
};

export const cdPost = async (
	path: string,
	payload: any,
	options = getConfig()
) => {
	const response = await axios.post(
		process.env.REACT_APP_deployed_URL + path,
		payload,
		options
	);

	return response;
};

export const getProductLevelData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getProductLevelData?category=${payload?.category}&customerId=${payload.customerId}&pageNumber=${payload?.currentPage}&pageSize=14`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const getItemLevelData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getItemLevelData?productType=${payload}`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const getDivisionLevelData = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getDivisionLevelData?productType=${payload.productType}&itemId=${payload.itemId}`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};
export const apiAcceptall = (payload: any, acceptAll = false) => {
	const queryService = new QueryService(BACKEND_API_URL);

	const updateData = async () => {
		let url = "/updateMarginBrainDataRec?flag=2";
		if (acceptAll) {
			url += `?isAll=1`;
		}

		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return updateData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in margin brain data update API --", err);
		});
};
export const apiUpdateMarginBrainDataRec = (
	payload: any,
	acceptAll = false
) => {
	const queryService = new QueryService(BACKEND_API_URL);

	const updateData = async () => {
		let url = "/updateMarginBrainDataRec";
		if (acceptAll) {
			url += `?isAll=1`;
		}

		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return updateData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in margin brain data update API --", err);
		});
};

export const apiUpdateMarginBrainDataRecitem = (
	payload: any,
	acceptAll = false
) => {
	const queryService = new QueryService(BACKEND_API_URL);

	const updateData = async () => {
		let url = "/updateMarginBrainDataRec?flag=1";
		if (acceptAll) {
			url += `?isAll=1`;
		}

		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return updateData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in margin brain data update API --", err);
		});
};

export const getAPI = (
	url: string,
	queryParamsinArrayOfObject: Array<GetAPIParams> = []
) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		queryParamsinArrayOfObject.forEach(
			(param: GetAPIParams, index: number) => {
				if (index === 0) {
					url += "?";
				}
				url += `${param.key.replace(/&/g, "%26")}=${param.value.replace(
					/&/g,
					"%26"
				)}`;
				if (index < queryParamsinArrayOfObject.length - 1) {
					url += "&";
				}
			}
		);
		const data = await queryService.runQuery(url, "GET");
		return data;
	};
	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Error in getAPI method");
		});
};

export const getBCIHistoricalTrend = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const fetchData = async () => {
		let url = `/getBCIHistoricalTrend?itemId=${payload.itemId}&DivisionID=${payload.DivisionID}`;
		const data = await queryService.runQuery(url, "GET");
		return data;
	};

	return fetchData()
		.then((data) => {
			return data;
		})
		.catch(() => {
			console.log("Could Not fetch data");
		});
};

export const UpdateSaveReason = (payload: any) => {
	const queryService = new QueryService(BACKEND_API_URL);
	const postData = async () => {
		let url = `/saveReasonBCI`;
		const data = await queryService.runQuery(url, "PUT", payload);
		return data;
	};

	return postData()
		.then((data) => {
			return data;
		})
		.catch((err: any) => {
			console.log("error in UpdateBrandCost update APi --", err);
		});
};
